module.exports = __webpack_public_path__ + "static/img/buying_for.e7efe731.jpg";